export const breakpoints = {
  "2xs": "320px",
  xs: "360px",
  sm: "480px",
  md: "740px",
  lg: "1100px",
  xl: "1420px",
  "2xl": "1600px",
};
